module.exports = __webpack_public_path__ + "static/img/Latrell-Mitchell.2317cc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Latrell-Mitchell.jpg
// module id = rY4Y
// module chunks = 0